// src/components/ModuleErrorBoundary.jsx
// Compact inline error boundary for individual module panels.
// Use key={activeTab} on the wrapper so it resets between tabs.
import { Component } from "react";

export default class ModuleErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error("Module crashed:", error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          padding: "40px 24px",
          textAlign: "center",
          fontFamily: "'IBM Plex Mono', 'Courier New', monospace",
        }}>
          <div style={{
            color: "#ff6b35",
            fontSize: 11,
            letterSpacing: "0.1em",
            marginBottom: 12,
          }}>
            ⚠ MODULE ERROR
          </div>
          <div style={{
            color: "#8b949e",
            fontSize: 12,
            marginBottom: 20,
          }}>
            This module encountered an error.
          </div>
          <button
            onClick={() => this.setState({ hasError: false })}
            style={{
              background: "transparent",
              border: "1px solid #3ddc84",
              color: "#3ddc84",
              padding: "8px 20px",
              cursor: "pointer",
              fontFamily: "inherit",
              fontSize: 11,
              letterSpacing: "0.08em",
            }}
          >
            Reload Module →
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
